module.exports = __webpack_public_path__ + "img/dr_3.7d3a5565.png";